@if (showCartBar) {
@if (selectedProductsCount > 0) {
<div class="d-flex ai-center bg-secondary rounded-8 jc-between gap-5 p-x-20 p-y-10 w-85 m-auto">
   <p class="f-s-16 f-w-300" [style.color]="categoryTitleColor">
      Adicionar {{ selectedProductsCount }} {{ selectedProductsCount > 1 ? 'itens' : 'item' }} ao carrinho
   </p>
   <div class="d-flex ai-center gap-10">
      <div class="footer-add-plus-btn d-flex ai-center jc-center rounded-circle bg-primary p-5 cursor-pointer"
         (click)="addSelectedProductsToCart()">
         <i-tabler name="plus" class="icon-40 stroke-2 text-text-color" />
      </div>
   </div>
</div>
} @else if ((order?.ItemsQuantity ?? 0) > 0) {
<div class="d-flex ai-center bg-secondary rounded-8 jc-between gap-5 p-x-20 p-y-10 w-85 m-auto"
   [style.color]="categoryTitleColor" [routerLink]="'/' + parameterization.FriendlyUrl + '/carrinho'"
   routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
   <div class="d-flex ai-center jc-center gap-5">
      <i-tabler [name]="(order?.ItemsQuantity ?? 0) > 0 ? 'shopping-cart' : 'shopping-cart-off'"
         class="icon-30 stroke-1" />
      <p class="f-s-16 f-w-300"> {{ order?.ItemsQuantity }} {{ (order?.ItemsQuantity ?? 0)
         > 1
         ? 'Itens' :
         'Item' }} </p>
   </div>
   <p class="f-s-16 f-w-300"> {{ (order?.TotalValue ?? 0) | customCurrency }} </p>
</div>
}
}
<footer class="bg-primary w-95 h-10 m-auto d-flex ai-center rounded-8 p-x-20">
   <div class="w-100 d-flex jc-around ai-center">
      <div class="d-flex flex-column ai-center jc-center gap-5 p-5 w-px-70 h-px-60"
         (click)="onOpenMenuConfigurationDialog()">
         <i-tabler name="menu-2" class="icon-25 stroke-1 text-text-color" />
      </div>
      <div class="d-flex flex-column ai-center jc-center gap-5 p-5 w-px-70 h-px-60"
         [routerLink]="'/' + parameterization.FriendlyUrl + '/app/produtos'" routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: true }">
         <i-tabler name="book" class="icon-25 stroke-1 text-text-color" />
         <p class="f-s-12 text-text-color f-w-300">Produtos</p>
      </div>
      <div class="d-flex flex-column ai-center jc-center gap-5 p-5 w-px-70 h-px-60"
         [routerLink]="'/' + parameterization.FriendlyUrl + '/app/pedidos'" routerLinkActive="active"
         [routerLinkActiveOptions]="{ exact: true }">
         <i-tabler name="list" class="icon-25 stroke-1 text-text-color" />
         <p class="f-s-12 text-text-color f-w-300">Pedidos</p>
      </div>
   </div>
</footer>